import { useI18n } from '@i18n';
import { area_type_enum } from '@predium/enums';
import { useCallback } from 'react';

export function useAreaTypeLabel() {
  const { t } = useI18n();

  return useCallback(
    (areaType: area_type_enum) => {
      switch (areaType) {
        case area_type_enum.MF:
          return t('DataCollectionAreas_TenantArea');
        case area_type_enum.AF:
          return t('DataCollectionAreas_CommonArea');
        case area_type_enum.NGF:
          return t('DataCollectionAreas_TotalBuilding');
        default:
          return '';
      }
    },
    [t],
  );
}
